// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background-color: white;
  padding-left: 12px;
  padding: 27px;
  height: 0px;
  position: fixed;
  top: 0;
  width: 100%;
  box-shadow: 0 1px 1px -1px gray;
  z-index: 1000;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.header-title {
  color: #d64000;
  font-weight: bold;
}

.user-info-container {
  display: flex;

  justify-content: flex-end;

  right: 4rem;
  position: absolute;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 15px; /* Matches user-greeting */
  transition: background 0.2s ease-in-out;
  background-color: #f4f4f9; /* Matches user-greeting */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.user-info-container:hover {
  background: #e6e6f0;
}

.user-greeting {
  padding: 5px 10px;
  font-weight: bold;
  color: #333;
}
.logout-box {
  position: absolute;
  top: 100%;
  right: 15px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 8px 12px;
  z-index: 1000;
  width: max-content;
}

.logout-box button {
  background: none;
  border: none;
  font-size: 14px;
  font-weight: bold;
  color: #000; /* Black color */
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 5px;
  transition: color 0.2s ease-in-out;
}
.logged-out-message {
  margin-top: 80px;
  text-align: center;
  font-size: 24px;
  color: #333;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/css/header.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;EACf,MAAM;EACN,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;;EAEb,yBAAyB;;EAEzB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB,EAAE,0BAA0B;EAC/C,uCAAuC;EACvC,yBAAyB,EAAE,0BAA0B;EACrD,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW,EAAE,gBAAgB;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".header {\n  background-color: white;\n  padding-left: 12px;\n  padding: 27px;\n  height: 0px;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  box-shadow: 0 1px 1px -1px gray;\n  z-index: 1000;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.header-title {\n  color: #d64000;\n  font-weight: bold;\n}\n\n.user-info-container {\n  display: flex;\n\n  justify-content: flex-end;\n\n  right: 4rem;\n  position: absolute;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 15px; /* Matches user-greeting */\n  transition: background 0.2s ease-in-out;\n  background-color: #f4f4f9; /* Matches user-greeting */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.user-info-container:hover {\n  background: #e6e6f0;\n}\n\n.user-greeting {\n  padding: 5px 10px;\n  font-weight: bold;\n  color: #333;\n}\n.logout-box {\n  position: absolute;\n  top: 100%;\n  right: 15px;\n  background: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  padding: 8px 12px;\n  z-index: 1000;\n  width: max-content;\n}\n\n.logout-box button {\n  background: none;\n  border: none;\n  font-size: 14px;\n  font-weight: bold;\n  color: #000; /* Black color */\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 5px;\n  transition: color 0.2s ease-in-out;\n}\n.logged-out-message {\n  margin-top: 80px;\n  text-align: center;\n  font-size: 24px;\n  color: #333;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
